import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { P } from '@/app/guards';
import {
  Coffre,
  Comptabilite,
  GoogleReviews,
  MagicSms,
  OperationsCommerciales,
  PersonnalisationDocs,
  ProfilsAcces,
  Promotions,
  ReferralProgram,
  RewardsStore,
  SmsMarketing,
  TransfertComptable,
  Utilisateurs,
  MouvementsFidelite,
  CartesCadeaux,
  FacturationBl,
  FacturesClients,
  Devis,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function commerceRoutes() {
  return (
    <>
      <Route
        path="/mouvements-fidelite"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <MouvementsFidelite />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/cartes-cadeaux"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CartesCadeaux />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/sms-marketing"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <MagicSms />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/sms-marketing/legacy"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <SmsMarketing />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/magic-sms"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <MagicSms />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/rewards-store"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <RewardsStore />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/referral"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ReferralProgram />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/google-reviews"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <GoogleReviews />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/promotions"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Promotions />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/operations-commerciales"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <OperationsCommerciales />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/personnalisation-docs"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <PersonnalisationDocs />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/coffre"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Coffre />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/comptabilite"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Comptabilite />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/transfert-comptable"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TransfertComptable />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/utilisateurs"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Utilisateurs />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/profils-acces"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ProfilsAcces />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/facturation-bl"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FacturationBl />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/devis"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Devis />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/factures-clients"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FacturesClients />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
    </>
  );
}
